/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/skip */
import{filter as i}from"rxjs/dist/esm/internal/operators/filter";function f(r){return i((o,t)=>r<=t)}export{f as skip};
//# sourceMappingURL=skip.mjs.map